import { ActionConstants } from '../constants';

const receiver = (state = null, action) => {
  switch (action.type) {
    case ActionConstants.ADD_RECEIVER:
      return {
        id: action.payload.id,
        username: action.payload.username,
      }
    case ActionConstants.DELETE_RECEIVER:
      return null;
    default:
      return state;
  }
}

export default receiver


// WEBPACK FOOTER //
// ./src/reducers/receiver.js